// extracted by mini-css-extract-plugin
module.exports = {"tooltipWrapper":"LockedMeetingTooltip_tooltipWrapper__20me_","spin360":"LockedMeetingTooltip_spin360__3pc3b"};